import React, { useState, createElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, DownloadIcon, ZoomInIcon, ZoomOutIcon, PrinterIcon } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
export const EnglishSuite2Bourree1Viewer: React.FC = () => {
  const navigate = useNavigate();
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const [zoom, setZoom] = useState(100);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const pdfUrl = 'https://www.mutopiaproject.org/ftp/BachJS/BWV807/bach-english-suite-2-bourree-1/bach-english-suite-2-bourree-1-a4.pdf';
  const pdfViewUrl = isMobile ? `${pdfUrl}#view=Fit&zoom=page-width` : `${pdfUrl}#view=FitH`;
  const handleZoomIn = () => setZoom(prev => Math.min(prev + 10, 200));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 10, 50));
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Bach - English Suite No. 2 Bourree I BWV 807.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handlePrint = () => {
    window.print();
  };
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gray-50'}`} data-id="element-3637">
      <Navbar data-id="element-3638" />

      <div className="pt-20" data-id="element-3639">
        <div className="relative w-full" style={{
        minHeight: '320px'
      }} data-id="element-3640">
          <img src="https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=1200&h=400&fit=crop" alt="English Suite No. 2 – Bourrée I" className="w-full h-64 md:h-80 object-cover" data-id="element-3641" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/30 to-black/70" data-id="element-3642" />
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8" data-id="element-3643">
            <div className="max-w-7xl mx-auto" data-id="element-3644">
              <button onClick={() => navigate(-1)} className="mb-4 flex items-center text-white/90 hover:text-white transition-colors" data-id="element-3645">
                <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-3646" />
                Back to Library
              </button>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2" data-id="element-3647">
                English Suite No. 2 – Bourrée I
              </h1>
              <p className="text-lg md:text-xl text-white/90" data-id="element-3648">BWV 807</p>
              <p className="text-base md:text-lg text-white/80 mt-1" data-id="element-3649">
                Johann Sebastian Bach
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Toolbar */}
      <div className={`sticky top-20 z-10 ${isDark ? 'bg-navy-800/95 backdrop-blur-sm border-b border-white/10' : 'bg-white/95 backdrop-blur-sm border-b border-gray-200'} shadow-sm`} data-id="element-3650">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-3651">
          <div className="flex items-center space-x-2" data-id="element-3652">
            {!isMobile && <>
                <button onClick={handleZoomOut} className={`p-2 rounded-lg transition-colors ${isDark ? 'hover:bg-navy-700 text-white' : 'hover:bg-gray-100 text-gray-800'}`} aria-label="Zoom out" data-id="element-3653">
                  <ZoomOutIcon className="h-5 w-5" data-id="element-3654" />
                </button>
                <span className={`text-sm font-medium px-3 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-3655">
                  {zoom}%
                </span>
                <button onClick={handleZoomIn} className={`p-2 rounded-lg transition-colors ${isDark ? 'hover:bg-navy-700 text-white' : 'hover:bg-gray-100 text-gray-800'}`} aria-label="Zoom in" data-id="element-3656">
                  <ZoomInIcon className="h-5 w-5" data-id="element-3657" />
                </button>
              </>}
          </div>
          <div className="flex items-center space-x-2" data-id="element-3658">
            <button onClick={handlePrint} className={`flex items-center justify-center px-4 py-2 rounded-lg transition-colors ${isDark ? 'hover:bg-navy-700 text-white border border-navy-700' : 'hover:bg-gray-100 text-gray-800 border border-gray-200'}`} data-id="element-3659">
              <PrinterIcon className="h-4 w-4 sm:mr-2" data-id="element-3660" />
              <span className="hidden sm:inline" data-id="element-3661">Print</span>
            </button>
            <button onClick={handleDownload} className="flex items-center justify-center px-4 py-2 border-2 border-green-500 text-green-500 bg-transparent hover:bg-green-500/10 rounded-lg transition-colors" data-id="element-3662">
              <DownloadIcon className="h-4 w-4 sm:mr-2" data-id="element-3663" />
              <span className="hidden sm:inline" data-id="element-3664">Download PDF</span>
            </button>
          </div>
        </div>
      </div>

      {/* Sheet Music Viewer */}
      <main className="max-w-7xl mx-auto px-4 py-8" data-id="element-3665">
        <div className={`rounded-xl overflow-hidden shadow-lg ${isDark ? 'bg-navy-800' : 'bg-white'}`} data-id="element-3666">
          <div className="w-full" style={{
          height: 'calc(100vh - 300px)',
          minHeight: '600px'
        }} data-id="element-3667">
            <iframe src={pdfViewUrl} className="w-full h-full" title="English Suite No. 2 – Bourrée I Sheet Music" style={{
            border: 'none',
            ...(isMobile ? {} : {
              transform: `scale(${zoom / 100})`,
              transformOrigin: 'top center',
              transition: 'transform 0.2s ease'
            })
          }} data-id="element-3668" />
          </div>
        </div>

        {/* Piece Information */}
        <div className={`mt-8 rounded-xl p-6 ${isDark ? 'bg-navy-800' : 'bg-white'} shadow-sm`} data-id="element-3669">
          <h2 className={`text-2xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-3670">
            About This Piece
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-3671">
            <div data-id="element-3672">
              <h3 className={`text-lg font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-3673">
                Composition Details
              </h3>
              <dl className="space-y-2" data-id="element-3674">
                <div data-id="element-3675">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-3676">
                    Composer
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-3677">
                    Johann Sebastian Bach
                  </dd>
                </div>
                <div data-id="element-3678">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-3679">
                    Catalog
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-3680">
                    BWV 807
                  </dd>
                </div>
                <div data-id="element-3681">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-3682">
                    Instrument
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-3683">
                    Piano (Harpsichord)
                  </dd>
                </div>
                <div data-id="element-3684">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-3685">
                    Collection
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-3686">
                    English Suite No. 2 in A Minor
                  </dd>
                </div>
              </dl>
            </div>
            <div data-id="element-3687">
              <h3 className={`text-lg font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-3688">
                Performance Notes
              </h3>
              <p className={`text-sm leading-relaxed ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3689">
                The Bourrée I from Bach's English Suite No. 2 in A Minor (BWV
                807) is one of the most celebrated movements in the English
                Suites. Set in A minor, it carries a more serious and dramatic
                character compared to its counterpart in Suite No. 1. The
                driving rhythmic energy and contrapuntal writing make it a
                rewarding study in Baroque style, demanding clarity of
                articulation and a strong sense of rhythmic pulse.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-3690" />
    </div>;
};